module.exports = __webpack_public_path__ + "430812c9075813dc68542c749c89fae7.svg";